(function () {
    'use strict';

    angular.module("imApp").factory("vatReportService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3132,
                    parameters: parms || {}
                });
            },
            listTaxPeriods: function (parms) {
                return $ihttp.post({
                    method: 3131,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3133,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
